<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        id: string | number;
        aspectRatio?: string;
        provider: 'youtube' | 'vimeo';
    }>(),
    {
        aspectRatio: '16/9',
    }
);

const url = computed(() => {
    if (props.provider === 'youtube') {
        return `https://www.youtube-nocookie.com/embed/${props.id}?color=white&rel=0`;
    }

    if (props.provider === 'vimeo') {
        return `https://player.vimeo.com/video/${props.id}?badge=0&byline=0&color=06038d&dnt=1&portrait=0&title=0&vimeo_logo=0`;
    }

    throw new Error(`Provider ${props.provider} is not supported`);
});
</script>

<template>
    <div
        class="relative w-full overflow-hidden rounded-md"
        :style="{
            aspectRatio,
        }"
    >
        <iframe
            :src="url"
            class="absolute inset-0 size-full border-0"
            allowfullscreen
            scrolling="no"
            allow="encrypted-media *"
        ></iframe>
    </div>
</template>
